// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"790c6af9","administration":"7a11923a"}[chunkId] + ".chunk.js";
};